import { Button } from "../../../components/ui/button";
import { Heart } from "lucide-react";

export default function Donate() {
    return (
        <form
            action="https://www.paypal.com/donate"
            method="post"
            target="_top"
            className="flex justify-center pt-4 lg:pt-8"
        >
            <input type="hidden" name="hosted_button_id" value="PE4SWKUH7XTDC" />
            <Button type="submit" className='bg-green-600 hover:bg-green-900' size="lg">
                        <Heart />
                        Donate to our cause &rarr;
                    </Button>
        </form>
    );
}